import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import AnalyticsDatePickerModal from "../../../../components/modals/analyticsDatePicker/analyticsDatePickerModal";
import DocViewerWithSideNavigation from "../../../../components/modals/docViewerWithSideNavigation/docViewerWithSideNavigation";
import ImageviewerModal from "../../../../components/modals/imageViewerModal/imageviewerModal";
import { LocalStorageKeys } from "../../../../enums/localStorageKeys";
import { ModalId } from "../../../../enums/modalId";

import { limit, orderBy, where } from "firebase/firestore";

import moment from "moment";
import { FirestoreService } from "../../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../api/firebase/references";
import ImageViewerWithBadgesModal from "../../../../components/modals/imageViewerWithBadgesModal/imageViewerWithBadgesModal";
import { EXPORT_DATA_LIMIT } from "../../../../constants/medicalPAbatch";
import { MedicalPaOrder } from "../../../../data-model/medicalPaOrdersModel";
import { closeModal as closeReduxModal } from "../../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";
import {
  exportDataFromTableForMedicalPaOrdersExternal,
  exportDataToExcel,
} from "../../../../utils/exportDataToExcel";
import { setItemInLocalStorage } from "../../../../utils/localStorageHelper";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";
import AllPaOrdersForExternalTableByAlgolia from "./components/allPaOrdersForExternalTableByAlgolia";

const AllPaOrdersForExternal = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [showLoading, setShowLoading] = useState(false);
  const allPaOrdersForExternalTableRef = useRef<HTMLDivElement>(null);
  const { openedModalId, metaData } = useSelector(
    (state: RootState) => state.modal,
  );
  useEffect(() => {
    setItemInLocalStorage(
      LocalStorageKeys.PARENT_TABLE,
      window.location.pathname.split("/").slice(-1)[0],
    );
  }, []);

  useEffect(() => {
    if (openedModalId === ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION) {
      openModal(ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION);
    }
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.ANALYTICS_DATE_PICKER_MODAL) {
      openModal(ModalId.ANALYTICS_DATE_PICKER_MODAL);
    }
    if (openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL);
    }
  }, [openedModalId]);

  const handleDataFetchingForSelectedDateRange = async (
    startDate: Date,
    endDate: Date,
  ) => {
    try {
      setShowLoading(true);
      const startDateForExport = moment(startDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      const endOfDayendDateForExport = moment(endDate)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      const data = await FirestoreService.getDocumentsByQuery(
        FirestoreCollectionReference.medicalPaOrders(),
        [
          where("created_at", ">=", startDateForExport),
          where("created_at", "<=", endOfDayendDateForExport),
          where(
            "assigned_to.facility_id",
            "==",
            getOrgIdForFetchExternalWorklist(),
          ),
          orderBy("created_at", "desc"),
          limit(EXPORT_DATA_LIMIT),
        ],
      );
      const exportedData = exportDataFromTableForMedicalPaOrdersExternal(
        data as MedicalPaOrder[],
      );
      exportDataToExcel(
        exportedData,
        `PA Orders Export-${moment().format("YYYY-MM-DD")}`,
      );
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      setShowLoading(false);
    }
  };

  return (
    <div className="all-pa-orders-for-external--main-container flex h-full flex-col overflow-hidden">
      <div className="all-pa-orders-for-external__header mb-4 text-h11 font-bold text-primaryGray-1">
        All PA Orders
      </div>
      <div className="all-pa-orders-for-external__table-container flex-1 overflow-auto">
        <AllPaOrdersForExternalTableByAlgolia
          allPaOrdersForExternalTableRef={allPaOrdersForExternalTableRef}
          exportingInProgress={showLoading}
        />
      </div>
      <>
        {openedModalId === ModalId.IMAGE_VIEWER_MODAL && (
          <ImageviewerModal
            fileUrls={metaData?.fileUrls ?? []}
            filePaths={metaData?.filePaths ?? []}
            onClose={() => dispatch(closeReduxModal())}
            showLoader={metaData?.showLoader ?? false}
          />
        )}
        {openedModalId === ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION && (
          <DocViewerWithSideNavigation
            showLoader={metaData?.showLoader ?? false}
          />
        )}

        {openedModalId === ModalId.ANALYTICS_DATE_PICKER_MODAL && (
          <AnalyticsDatePickerModal
            onClose={() => dispatch(closeReduxModal())}
            onDateRangeSelect={(startDate, endDate) => {
              handleDataFetchingForSelectedDateRange(startDate, endDate);
            }}
            maxRecords={EXPORT_DATA_LIMIT}
          />
        )}
        {openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL && (
          <ImageViewerWithBadgesModal
            tabs={metaData?.tabs ?? []}
            showLoading={metaData?.showLoading ?? false}
            title="Write Back Trail"
          />
        )}
      </>
    </div>
  );
};

export default AllPaOrdersForExternal;
